import { createSelector } from 'reselect';

import { selectCommunicationsScreenReaderNotifications } from '../Communications/selectors';
import { selectLoansScreenReaderNotifications } from '../Loans/selectors';
import { selectProfileScreenReaderNotifications } from '../Profile/selectors';
import { selectSecurityScreenReaderNotifications } from '../Security/selectors';

const selectSettingsProps = (_, props) => props;

const selectPageSubView = () => createSelector(
  selectSettingsProps,
  (props) => props.match.params.subView || 'main',
);

const selectPageView = () => createSelector(
  selectSettingsProps,
  (props) => props.match.params.view || 'profile',
);

const selectSettingsScreenReaderNotifications = () => createSelector(
  selectCommunicationsScreenReaderNotifications(),
  selectLoansScreenReaderNotifications(),
  selectProfileScreenReaderNotifications(),
  selectSecurityScreenReaderNotifications(),
  (
    communicationsNotifications,
    loansNotifications,
    profileNotifications,
    securityNotifications,
  ) => [
    ...communicationsNotifications,
    ...loansNotifications,
    ...profileNotifications,
    ...securityNotifications,
  ],
);

export {
  selectPageSubView,
  selectPageView,
  selectSettingsScreenReaderNotifications,
};
